var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b',[_c('i',{class:'fas fa-star ' + _vm.getRatingClass(_vm.getSelectedDetails(_vm.plan).rating)}),_vm._v("\n    "+_vm._s(_vm.getSelectedDetails(_vm.plan).rating))])
}
var staticRenderFns = []

export { render, staticRenderFns }